import { Card, Col, Row, Typography, Image } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DocumentUI } from "../entity/document.model";
import documentPublicService from "../service/document.service";
import { CalendarOutlined, UserOutlined } from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

const DocumentList = () => {
  const { categoryUuid } = useParams<{ categoryUuid: string }>();
  const [documents, setDocuments] = useState<DocumentUI[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (categoryUuid) {
      loadDocuments();
    }
  }, [categoryUuid]);

  const loadDocuments = async () => {
    setLoading(true);
    try {
      const data = await documentPublicService.getDocumentsByCategory(
        categoryUuid!
      );
      setDocuments(data);
    } catch (error) {
      console.error("Failed to load documents:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("mn-MN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const stripHtml = (html: string) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };

  const getExcerpt = (content: string, maxLength: number = 150) => {
    const text = stripHtml(content);
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  return (
    <div style={{ padding: "40px 20px", margin: "0 auto" }}>
      <Title level={2} style={{ textAlign: "center", marginBottom: "40px" }}>
        {documents[0]?.documentCategory?.name || "Мэдээлэл"}
      </Title>

      <Row gutter={[24, 24]}>
        {documents.map((doc) => (
          <Col key={doc.uuid}>
            <Card
              style={{ width: "100%" }}
              hoverable
              loading={loading}
              cover={
                doc.mainImagePath && (
                  <div
                    style={{
                      height: "350px",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Image
                      alt={doc.title}
                      src={doc.mainImagePath}
                      preview={false}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                )
              }
              onClick={() => navigate(`/appversion/view/${doc.uuid}`)}
              style={{ height: "100%" }}
            >
              <Card.Meta
                title={
                  <Title level={4} ellipsis={{ rows: 2 }}>
                    {doc.title}
                  </Title>
                }
                description={
                  <>
                    <div style={{ marginBottom: "12px" }}>
                      <Text type="secondary" style={{ fontSize: "12px" }}>
                        <CalendarOutlined /> {formatDate(doc.createdDate)}
                        <span style={{ marginLeft: "12px" }}>
                          <UserOutlined /> {doc.username}
                        </span>
                      </Text>
                    </div>
                    <Paragraph
                      ellipsis={{ rows: 3 }}
                      style={{ marginBottom: 0 }}
                    >
                      {getExcerpt(doc.content).replace(/<[^>]+>/g, "")}
                    </Paragraph>
                  </>
                }
              />
            </Card>
          </Col>
        ))}
      </Row>

      <hr></hr>
      <br></br>

      {!loading && documents.length === 0 && (
        <div style={{ textAlign: "center", padding: "60px 0" }}>
          <Text type="secondary">Мэдээлэл олдсонгүй</Text>
        </div>
      )}
    </div>
  );
};

export default DocumentList;

